import React, { useEffect, useState } from 'react'
import './App.css'
import './fonts.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Hamburger from 'hamburger-react'
import { Home } from './routes/Home'
import { Bags } from './routes/Bags'
import { Sales2022 } from './routes/Sales2022'
import { Program as Program2020 } from './routes/ProgramFeb2020'
import { Program as Program2022 } from './routes/ProgramMay2022'
import { QR } from './routes/QR'
import styled, { css } from 'styled-components'
import background from './assets/hero-smaller.jpg'
// import Menu from './components/Menu'
import MenuItem, { MenuLink } from './components/MenuItem'
import { ProgramMay2024 } from './routes/ProgramMay2024'
import { ProgramYule2025 } from './routes/ProgramYule2025'
import { ProgramMay2026 } from './routes/ProgramMay2026'

const App: React.FC = () => {
  const [showMenu, setShowMenu] = useState(false)
  const [noMenu, setNoMenu] = useState(false)

  const handleMenuToggle = () => {
    setShowMenu(!showMenu)
  }

  const noMenuPaths = [
    '/jol-2022',
    '/efnisskra',
    '/efnisskra-vor-2024',
    '/efnisskra-jol-2025',
    '/efnisskra-vor-2026',
    '/efnisskra-2022',
    '/efnisskra-2020',
    '/qr',
  ]
  console.log('Current path:', window.location.pathname)
  console.log(
    'noMenuPaths.includes(window.location.pathname):',
    noMenuPaths.includes(window.location.pathname)
  )

  useEffect(() => {
    setNoMenu(noMenuPaths.includes(window.location.pathname))
  }, [])

  useEffect(() => {
    const handleLocationChange = () => {
      setNoMenu(noMenuPaths.includes(window.location.pathname))
    }

    window.addEventListener('popstate', handleLocationChange)

    return () => {
      window.removeEventListener('popstate', handleLocationChange)
    }
  }, [])

  useEffect(() => {
    console.log('noMenu state updated:', noMenu)
  }, [noMenu])

  return (
    <Root>
      <Header>
        <MobileMenuWrapper visible={!noMenu}>
          <Hamburger onToggle={handleMenuToggle} toggled={showMenu} />
        </MobileMenuWrapper>
        <MenuWrapper visible={!noMenu}>
          <MenuItemWrapper>
            <MenuItem
              itemName={'kórinn'}
              anchorName={'korinn'}
              onClick={handleMenuToggle}
            ></MenuItem>
          </MenuItemWrapper>
          <MenuItemWrapper>
            <MenuItem
              itemName={'stýrurnar'}
              anchorName={'styrurnar'}
              onClick={handleMenuToggle}
            ></MenuItem>
          </MenuItemWrapper>
          <MenuItemWrapper>
            <MenuItem
              itemName={'gigg'}
              anchorName={'gigg'}
              onClick={handleMenuToggle}
            ></MenuItem>
          </MenuItemWrapper>
          <MenuItemWrapper>
            <MenuItem
              itemName={'hafðu samband'}
              anchorName={'hafa-samband'}
              onClick={handleMenuToggle}
            ></MenuItem>
          </MenuItemWrapper>
          {/* <MenuItemWrapper>
            <MenuLink href={'/jol-2022'}>fjáröflun</MenuLink>
          </MenuItemWrapper> */}
        </MenuWrapper>
        {/* <Menu /> */}
        {/* <MobileMenu showMenu={showMenu}>
          <MenuItem
            itemName={'kórinn'}
            anchorName={'korinn'}
            onClick={handleMenuToggle}
          ></MenuItem>
          <MobileSeparator />
          <MenuItem
            itemName={'stýrurnar'}
            anchorName={'styrurnar'}
            onClick={handleMenuToggle}
          ></MenuItem>
          <MobileSeparator />
          <MenuItem
            itemName={'gigg'}
            anchorName={'gigg'}
            onClick={handleMenuToggle}
          ></MenuItem>
          <MobileSeparator />
          <MenuItem
            itemName={'hafa samband'}
            anchorName={'hafa-samband'}
            onClick={handleMenuToggle}
          ></MenuItem>
          <MobileSeparator />
          <MenuLink href={'/jol-2022'}>Fjáröflun</MenuLink>
        </MobileMenu> */}

        {/* Oh no what horrible shitmix 🙃 */}

        {/* <MobileMenuWrapper visible={noMenu}>
          <Hamburger onToggle={handleMenuToggle} toggled={showMenu} />
        </MobileMenuWrapper>
        <MenuWrapper visible={noMenu}>
          <MenuItemWrapper>
            <MenuLink href={'/#korinn'}>kórinn</MenuLink>
          </MenuItemWrapper>
          <MenuItemWrapper>
            <MenuLink href={'/#styrurnar'}>stýrurnar</MenuLink>
          </MenuItemWrapper>
          <MenuItemWrapper>
            <MenuLink href={'/#gigg'}>gigg</MenuLink>
          </MenuItemWrapper>
          <MenuItemWrapper>
            <MenuLink href={'/#hafa-samband'}>hafðu samband</MenuLink>
          </MenuItemWrapper>
          <MenuItemWrapper>
            <MenuLink href={'/jol-2022'}>fjáröflun</MenuLink>
          </MenuItemWrapper>
        </MenuWrapper> */}
        {/* <Menu /> */}
        <MobileMenu showMenu={showMenu}>
          <MenuLink href={'/#korinn'}>kórinn</MenuLink>
          <MobileSeparator />
          <MenuLink href={'/#styrurnar'}>stýrurnar</MenuLink>
          <MobileSeparator />
          <MenuLink href={'/#gigg'}>gigg</MenuLink>
          <MobileSeparator />
          <MenuLink href={'/#hafa-samband'}>hafðu samband</MenuLink>
          <MobileSeparator />
          <MenuLink href={'/jol-2022'}>Fjáröflun</MenuLink>
        </MobileMenu>
      </Header>
      <Router>
        <Routes>
          <Route path="/pokasala" element={<Bags />} />
          <Route path="/jol-2022" element={<Sales2022 />} />
          <Route path="/efnisskra" element={<ProgramMay2026 />} />
          <Route path="/efnisskra-vor-2024" element={<ProgramMay2024 />} />
          <Route path="/efnisskra-jol-2025" element={<ProgramYule2025 />} />
          <Route path="/efnisskra-2022" element={<Program2022 />} />
          <Route path="/efnisskra-2020" element={<Program2020 />} />
          <Route
            path="/efnisskra-vortonleikar-2024"
            element={<ProgramMay2024 />}
          />
          <Route path="/qr" element={<QR />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </Root>
  )
}

export default App

const Root = styled.div`
  text-align: center;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;

  @media screen and (max-width: 700px) {
    background-position-x: -28rem;
  }
`

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: black;
  position: absolute;
  width: 100%;

  z-index: 500;
`

const MobileMenuWrapper = styled.span<{ visible: boolean }>`
  ${({ visible }) => css`
    position: absolute;
    right: 1rem;
    top: 1rem;

    ${visible ? 'display: block;' : 'display: none;'}

    @media (min-width: 401px) {
      display: none;
    }
  `}
`

const MenuWrapper = styled.ul<{ visible: boolean }>`
  ${({ visible }) => css`
    margin-top: 2rem;
    list-style: none;

    @media (max-width: 400px) {
      display: none;
    }
    ${visible ? 'display: block;' : 'display: none;'}
  `}
`

const MenuItemWrapper = styled.li`
  display: inline-flex;
  padding: 0 1rem;
  &:not(:last-of-type) {
    border-right: 1px solid black;
  }
`

const MobileMenu = styled.div<{ showMenu: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ showMenu }) => css`
    ${showMenu
      ? 'height: 100vh; width: 100vw; background-color: rgba(207, 156, 160, 1);'
      : 'display: none;'}
  `}
  @media (min-width: 401px) {
    display: none;
  }
`

const MobileSeparator = styled.div`
  height: 1px;
  width: 2rem;
  border-bottom: 1px black solid;
  @media (min-width: 401px) {
    display: none;
  }
`
